import script from "./ProviderSelection.vue?vue&type=script&setup=true&lang=js"
export * from "./ProviderSelection.vue?vue&type=script&setup=true&lang=js"

import "./ProviderSelection.vue?vue&type=style&index=0&id=00b6480a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00b6480a"]])

export default __exports__